// Copyright (c) StrangeBee 2024

import React, { createContext, ReactElement, Reducer, useContext, useReducer } from 'react';

type StateProviderProps = {
    reducer?: Reducer<any, any>;
    initialState: any;
    children: ReactElement;
};

export const StateContext = createContext({});
export const StateProvider = ({
    reducer = (s, {}: any) => s,
    initialState,
    children,
}: StateProviderProps): ReactElement => (
    <StateContext.Provider value={useReducer(reducer, initialState)}>{children}</StateContext.Provider>
);
export const useStateValue = (): any => useContext(StateContext) as any;
